import React from 'react'
import PropTypes from 'prop-types'
import photo from '../images/bianca-de-graaff.jpg'

export default class Hero extends React.Component {
  render() {
    return (
      <div className="Hero">
        <div className="inner">
          <div className="Hero-left">
            <img className="Hero-photo" src={photo} alt="Bianca De Graaff" />
          </div>

          <div className="Hero-right">
            <h1 className="heading-yellow">
              <em>Onafhankelijk</em> Financieel Advies
            </h1>
            <p className="text-white">
              Wil je een huis kopen, je hypotheekrente verlengen, je financiën
              op orde brengen, besparen op je verzekeringen of heb je andere
              vragen?
              <br />
              <br />
              <b>Wij kunnen je helpen.</b>
            </p>
          </div>
        </div>
        <div className="svg-container">
          <svg width="1440px" viewBox="0 0 1440 60">
            <g id="hero-bottom" fill="#FFFFFF" fillRule="nonzero">
              <path
                d="M0,60 L0,0 C548.949848,1.26925875e-14 823.425766,59.241375 1440,59.241375 L1440,60 L0,60 Z"
                id="Shape"
                transform="translate(720.000000, 30.000000) scale(-1, 1) translate(-720.000000, -30.000000) "
              />
            </g>
          </svg>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Hero.js